import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};
export const schemaLoanRequestResolver_GetEuropaceProcessId = LoanRequestsTableDefinitionZod.shape.europace
    .unwrap()
    .shape.id.nullable();

export type SchemaLoanRequestResolver_GetEuropaceProcessId = z.infer<
    typeof schemaLoanRequestResolver_GetEuropaceProcessId
>;

export type LoanRequestResolver_GetEuropaceProcessId = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetEuropaceProcessId
>;
